/** Dark tile shell shared by the real tile and its loading skeleton, so the
 *  grid keeps its geometry while items load. Surface flows through
 *  `--co-WhatsInsideItem-*`. */
export const TILE_CLASSES =
  'relative aspect-[175/296] overflow-hidden ' +
  '[border-radius:var(--co-WhatsInsideItem-borderRadius,18px)] ' +
  'border border-solid [border-color:var(--co-WhatsInsideItem-borderColor,rgba(255,255,255,0.01))] ' +
  'bg-[var(--co-WhatsInsideItem-background,#1A1B1F)]';
